import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';
import { DateTime } from 'common/utils/date';

class StarRatingClass extends Component {
  render() {
    let options = {
      plugins: {
        tooltip: {
          mode: 'nearest',
          footerMarginTop: 10,
          callbacks: {
            title: tooltipItems => {
              return `Week of ${DateTime.fromISO(tooltipItems[0].label).toLocaleString(
                DateTime.DATE_SHORT
              )}`;
            },
            labelColor: tooltipItem => {
              let datasetIndex = tooltipItem.datasetIndex;
              let color = tooltipItem.chart.data.datasets[datasetIndex].pointBackgroundColor;
              return { borderColor: 'transparent', backgroundColor: color };
            },
          },
        },
      },
      scales: {
        x: {
          display: false,
        },
      },
    };

    return (
      <BaseChart
        type="line"
        id="starRatingOverTimeWithTeamAndCompany"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="created_at"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default StarRatingClass;
